import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router';
import { useData } from '@hooks/useData';
import { useLogLocation } from '@services/useLogLocation';

export const UserGeoLocation = () => {
    const { allSettings, login, user } = useData();
    const { request: requestLogLocation } = useLogLocation();
    const [latitude, setLatitude] = useState<number | null>(null);
    const [longitude, setLongitude] = useState<number | null>(null);
    const [loading, setLoading] = useState(true);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [geoError, setGeoError] = useState<string | null>(null);

    useEffect(() => {
        if (!navigator.geolocation) {
            setGeoError('Geolocation not supported');
            setLoading(false);
            return;
        }

        const success = (position: GeolocationPosition) => {
            setLatitude(position.coords.latitude);
            setLongitude(position.coords.longitude);
            setLoading(false);
        };

        const fail = (err: GeolocationPositionError) => {
            setGeoError(err.message);
            setLoading(false);
        };

        const watcherId = navigator.geolocation.watchPosition(success, fail, {
            enableHighAccuracy: false,
            maximumAge: 1000,
            timeout: 60000,
        });

        return () => navigator.geolocation.clearWatch(watcherId);
    }, []);

    useEffect(() => {
        const intervalMinutes = Number(allSettings?.data?.locationUpdateInterval) || 0;
        const intervalMs = intervalMinutes * 60 * 1000;

        if (!login || intervalMinutes === 0) {
            return;
        }

        const intervalId = setInterval(() => {
            if (user?.data?.share_location) {
                if (loading || latitude == null || longitude == null) {
                    return;
                }
                requestLogLocation({
                    latitude: latitude,
                    longitude: longitude,
                });
            }
        }, intervalMs);

        return () => clearInterval(intervalId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user?.data?.share_location, latitude, longitude, allSettings?.data]);

    return (
        <>
            <Outlet />
        </>
    );
};
